import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { MatApoyo } from "../Generals";
import { capitalizeWord } from "../../../Generals/functions";
import { getAutoridadesEntidad } from "../../../Generals/autoridadesElectorales";


export default function Lesson2({ data, setLoading, objEntidad, origen }) {
  const isMounted = useRef(true);
  //Se obtiene el Entidad seleccionada del store de redux
  const { entidad, idEntidad } = useSelector((state) => state.entidad);
  //State-Redux

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  if(idEntidad!==undefined){
    localStorage.setItem('idEntidad', idEntidad);
  }

  useEffect(() => {
    window.scrollTo(0, 0); // para posicionar el scroll al inicio
  }, []);

  //función que ontiene los datos de la entidad dependiendo si se visualiza la lección dsde el curso o desde materiales de capacitación
  const getDataEntidad = () =>{
    const dataEntidad = origen === 1 ?objEntidad : {idEntidad: idEntidad, entidad: entidad};
    return dataEntidad
  }
  return (
    <>
      <div className="texto_parrafo">
        <p>
          En el sistema electoral mexicano la voluntad de la ciudadanía es un elemento fundamental, 
          pues a través de ella se hace posible la representación popular, por lo que las personas 
          que han cumplido 18 años y tienen un modo honesto de vivir adquieren la calidad de ciudadanas 
          o ciudadanos, la cual les otorga derechos y obligaciones.
        </p>
        <p>
          El votar constituye simultáneamente un derecho y una obligación de la ciudadanía y forma 
          parte de los derechos político-electorales reconocidos como derechos humanos.
        </p>
        <p>
          Por eso, debes tener presente qué se requiere para poder votar. En el siguiente material 
          te decimos cuáles son esos requisitos y las características del voto.
        </p>
        {data && data.indexOf(0) && <MatApoyo array={[data[0]]} />}
        <p>
          El sistema electoral mexicano es el conjunto de actores, normas y procedimientos involucrados 
          en el proceso electoral, encaminados a la conformación de los poderes Ejecutivo y 
          Legislativo de la Unión, de las entidades federativas, la renovación periódica de sus integrantes, 
          así como los mecanismos de participación ciudadana.
        </p>
        <p>
        Uno de los actores que intervienen en el proceso electoral son las autoridades electorales. 
        De acuerdo con su ámbito territorial de competencia se clasifican en <b>autoridades electorales 
        federales y autoridades electorales locales.</b>
        </p>
        <p>
        Las autoridades electorales federales son el Instituto Nacional Electoral (INE), el Tribunal Electoral 
        del Poder Judicial de la Federación (TEPJF) y la Fiscalía Especializada en materia de Delitos Electorales (FISEL).
        </p>
        {data && data.indexOf(1) && <MatApoyo array={[data[1]]} />}
        <p>
        En el siguiente video te describimos a las autoridades electorales federales, su naturaleza, estructura 
        y principales atribuciones. 
        </p>
        {data && data.indexOf(2) && <MatApoyo array={[data[2]]} />}
        <p>
        Es momento de conocer a las autoridades electorales locales, pero antes te invitamos a reforzar lo 
        aprendido. Ingresa al siguiente enlace:
        </p>
        {data && data.indexOf(3) && <MatApoyo array={[data[3]]} />}
        <p>
        Las autoridades electorales locales {parseInt(getDataEntidad().idEntidad) === 15 
                ? capitalizeWord(getDataEntidad().entidad).replace('el', 'del') 
                : 'de '+capitalizeWord(getDataEntidad().entidad)} son {getAutoridadesEntidad(parseInt(getDataEntidad().idEntidad))}
        </p>
        {data && data.indexOf(4) && <MatApoyo array={[data[4]]} />}
        <p>
        En el siguiente video te presentamos a las autoridades electorales locales, su naturaleza, estructura y principales atribuciones.
        </p>
        {data && data.indexOf(5) && <MatApoyo array={[data[5]]} />}
        <p>
         El próximo 2 de junio de 2024, en {capitalizeWord(getDataEntidad().entidad)} se celebrarán elecciones concurrentes. ¿Ya sabes qué cargos se elegirán? Aquí te decimos:
        </p>
        {data && data.indexOf(6) && <MatApoyo array={[data[6]]} />}
        <p>
        Los cargos que se elegirán se designarán mediante dos principios: <b>mayoría relativa</b> y <b> representación proporcional:</b>
        </p>
        <div className="listPunto"><b>Mayoría relativa:</b> cuando gana el partido o candidatura que obtiene el mayor número de votos en determinada área geográfica.</div>
        <div className="listPunto"><b>Representación proporcional:</b> es la asignación de cargos con base en el porcentaje de votación general obtenida por cada partido político en una región geográfica.</div>
        <br/>
        <p>
        Para comprender cómo se establecen estos principios es importante que conozcas el <b>marco geográfico electoral
        local</b>, el cual se refiere al espacio geográfico que determina la distribución de las y los ciudadanos que pueden 
        votar y que sirve de base para la planeación y la organización de los procesos electorales. 
        </p>
        <p>
        Los detalles del sistema electoral mexicano los puedes consultar en el <b className="textoResaltado2">CAPÍTULO 2 
        </b> de tu <b className="textoResaltado2">{data && data.indexOf(8) && <MatApoyo array={[data[8]]} tipo={1}/>}</b> y 
        sus respectivos anexos, que se encuentran a tu disposición en el material de consulta de este curso.
        </p>
        <p>
        A continuación, revisa el siguiente material de apoyo para reforzar lo que aprendiste.
        </p>
        {data && data.indexOf(7) && <MatApoyo array={[data[7]]} />} 
        <p>
        Ahora que ya sabes cuáles son las autoridades electorales tanto federales como locales, así como sus atribuciones, naturaleza e integración, realiza la actividad de autoevaluación para reforzar tu aprendizaje. Después podrás continuar con la siguiente lección.   
        </p>
      </div>
    </>
  );
}
